import {init} from '../common/init.js';
import {dialogs} from '../common/dialogs.js';
import {browserCheck} from '../common/browserCheck.js';
import {hfCommon} from '../common/common.js';

window.initPage = function () {
	var popupPlayer = $("#videoPlayerContainer");

	$("#videoPopup").dialog({
		autoOpen: false,
		modal: true,
		width: 'auto',
		resizable: false,
		buttons: {
			'Close': function () {
				$(this).dialog('close');
			}
		},
		open: function () {
			hfCommon.resizeHandler();
			//$.when(popupPlayerReady).done(function () {
			// popupPlayer.src({
			//     type: "video/mp4",
			//     src: $("#videoPopup").data('src')
			// });
			// popupPlayer.play();
			//});
			$(document).on('click.closeVideo', function (e) {
				if ($(e.target).closest("#videoPopup").length === 0) {
					$("#videoPopup").dialog('close');
				}
			});

		},
		close: function () {
			$(document).unbind('click.closeVideo');
			if (popupPlayer) {
				popupPlayer.find('video')[0].pause();

				popupPlayer.empty();

			}
			popupPlayer.css({
				height: '',
				width: '',
			});
		}
	});

	$("a.playVideoLink").click(function (e) {
		e.preventDefault();
		var link = $(this);
		var aspectRatio = 0.75;
		var filename = HF_GLOBALS.BASE_PATH + link.attr('href');
		if (link.data('aspectratio')) {
			aspectRatio = link.data('aspectratio');

		} else {
			var classes = link.attr('class').split(' ');
			for (var i = 0; i < classes.length; i++) {
				var matches = /^aspect(.+)/.exec(classes[i]);
				if (matches !== null) {
					aspectRatio = matches[1].replace('aspect', '') / 10000;
				}
			}
		}

		$("#videoPopup").data('aspectratio', aspectRatio);
		$("#videoPlayerContainer").removeClass(function (index, css) {
			return (css.match(/(^|\s)aspect\d+/g) || []).join(' ');
		});
		$("#videoPlayerContainer");

		popupPlayer.empty().append(
			$('<video style="position:absolute;height:100%" controls autoplay/>').append($('<source/>').attr({
				src: filename,
				type: 'video/mp4'
			}))).append($('<span/>').addClass('videoSpacer').css('padding-top', `${aspectRatio*100}%` ));

		if (browserCheck.isIOSHandHeld()) {

			// popupPlayer.src({
			//     type: "video/mp4",
			//     src: filename
			// });
			$("#videoPlayerContainer").appendTo($('body'))
				.addClass('iosPlay')
				.one('click', function () {
					$("#featuresBox h2").after($("#videoPlayerContainer").removeClass('iosPlay'));
				});

			$("#videoPlayerContainer video").on('webkitendfullscreen', function (e) {
				$("#videoPopup").prepend($("#videoPlayerContainer").removeClass('iosPlay'));
			});
			popupPlayer.play();
			$("#videoPlayerContainer video").one('durationchange', function () {
				popupPlayer.play();
			});
			return;
		} else {
			dialogs.openDialog($("#videoPopup"));
		}
		return false;
	});
}

init.init();
$(document).ready(function() {
	init.initPage();
});
